import axios from '../../axios';
import { GetInvoicesDto } from '../../../models/dtos/getInvoices.dto';

export default async function getInvoicesProblemRepository(
  active: string
): Promise<GetInvoicesDto[]> {
  const res = await axios.get<GetInvoicesDto[]>(
    `${process.env.REACT_APP_BASE_URL}/invoice/problem`,
    {
      params: {
        active,
      },
    }
  );
  return res.data;
}
